import React from "react";
import WaveText from "../WaveText";

export default function FillInTheGapsGeneratorPanel({
  showFillInTheGapsGenerator, generatedFillInTheGaps, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showErrorCorrectionGenerator, showGrammarRulesGenerator,
  fillInTheGapsMode, setFillInTheGapsMode,
  fillInTheGapsInput, setFillInTheGapsInput, fillInTheGapsLevel, setFillInTheGapsLevel,
  fillInTheGapsLoading, fillInTheGapsCustomText, setFillInTheGapsCustomText,
  setGeneratedFillInTheGaps,
  fitgTextareaRef, handleMarkGapInText,
  handleFillInTheGapsGenerate, handleFillInTheGapsInsertCustom,
  handleFillInTheGapsInsert, handleFillInTheGapsCancel,
}) {
  if (!((showFillInTheGapsGenerator || generatedFillInTheGaps) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleFillInTheGapsCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4 }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Fill in the Gaps Exercise</span>
      </div>

      {/* Mode toggle */}
      <div style={{ display: 'flex', gap: 6 }}>
        {[{ id: 'generate', label: '✨ Generate' }, { id: 'custom', label: '📝 My text' }].map(m => (
          <button key={m.id} onClick={() => { setFillInTheGapsMode(m.id); setGeneratedFillInTheGaps(null); }}
            style={{ flex: 1, padding: '7px 10px', borderRadius: 8, border: '1.5px solid', fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all 0.18s',
              borderColor: fillInTheGapsMode === m.id ? '#8a2be2' : '#e0e0e0',
              background: fillInTheGapsMode === m.id ? '#f3e8ff' : '#fafafa',
              color: fillInTheGapsMode === m.id ? '#8a2be2' : '#666' }}>
            {m.label}
          </button>
        ))}
      </div>

      {/* Generate mode */}
      {fillInTheGapsMode === 'generate' && (
        <>
          <textarea
            value={fillInTheGapsInput}
            onChange={e => setFillInTheGapsInput(e.target.value)}
            placeholder="Enter words or phrases (one per line or separated by commas)..."
            rows={4}
            style={{ fontSize: 15, padding: '12px', borderRadius: 8, border: '1.5px solid #cfcfff', background: '#f7fbff', resize: 'vertical', fontFamily: 'Inter, Segoe UI, Arial, sans-serif', width: '100%', boxSizing: 'border-box' }}
          />
          <div style={{ display: 'flex', gap: 8 }}>
            <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
              CEFR Level:
              <select value={fillInTheGapsLevel} onChange={e => setFillInTheGapsLevel(e.target.value)}
                style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer' }}>
                <option value="A1">A1 - Beginner</option>
                <option value="A2">A2 - Elementary</option>
                <option value="B1">B1 - Intermediate</option>
                <option value="B2">B2 - Upper Intermediate</option>
                <option value="C1">C1 - Advanced</option>
                <option value="C2">C2 - Mastery</option>
              </select>
            </label>
          </div>
          <button onClick={handleFillInTheGapsGenerate} disabled={fillInTheGapsLoading || !fillInTheGapsInput.trim()}
            className={fillInTheGapsLoading ? 'magic-generating-btn' : 'magic-btn'}
            style={{ fontSize: 15, padding: '12px 16px', borderRadius: 8, border: 'none', fontWeight: 600, cursor: fillInTheGapsLoading || !fillInTheGapsInput.trim() ? 'not-allowed' : 'pointer', transition: 'all 0.2s',
              background: fillInTheGapsLoading || !fillInTheGapsInput.trim() ? '#e0e0e0' : '#8a2be2',
              color: fillInTheGapsLoading || !fillInTheGapsInput.trim() ? '#999' : '#fff' }}>
            {fillInTheGapsLoading ? <WaveText /> : 'Do the magic'}
          </button>
          {generatedFillInTheGaps && (
            <div style={{ padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 4 }}>Generated: Fill in the Gaps Exercise</div>
              <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 10 }}>{generatedFillInTheGaps.sentences.length} sentences ready</div>
              <button onClick={handleFillInTheGapsInsert} className="magic-btn"
                style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}>
                Add
              </button>
            </div>
          )}
        </>
      )}

      {/* My text mode */}
      {fillInTheGapsMode === 'custom' && (
        <>
          <div style={{ fontSize: 13, color: '#6c757d', lineHeight: 1.5 }}>
            Paste your text below. Select a word and click <strong style={{ color: '#8a2be2' }}>B</strong> to mark it as a gap.
          </div>
          <div style={{ position: 'relative' }}>
            <textarea
              ref={fitgTextareaRef}
              value={fillInTheGapsCustomText}
              onChange={e => setFillInTheGapsCustomText(e.target.value)}
              placeholder={"Paste your text here, one sentence per line.\nExample: She **goes** to school every day."}
              rows={6}
              style={{ fontSize: 15, padding: '12px', paddingRight: '48px', borderRadius: 8, border: '1.5px solid #cfcfff', background: '#f7fbff', resize: 'vertical', fontFamily: 'Inter, Segoe UI, Arial, sans-serif', width: '100%', boxSizing: 'border-box', lineHeight: 1.6 }}
            />
            <button
              onClick={handleMarkGapInText}
              title="Mark selected word as gap"
              style={{ position: 'absolute', top: 8, right: 8, width: 32, height: 32, borderRadius: 7, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer', fontWeight: 800, fontSize: 15, color: '#8a2be2', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
              B
            </button>
          </div>
          {/* Preview of marked gaps */}
          {fillInTheGapsCustomText && (() => {
            const count = (fillInTheGapsCustomText.match(/\*\*(.+?)\*\*/g) || []).length;
            return count > 0 ? (
              <div style={{ fontSize: 13, color: '#8a2be2', background: '#f3e8ff', borderRadius: 7, padding: '7px 12px' }}>
                {count} gap{count !== 1 ? 's' : ''} marked
              </div>
            ) : null;
          })()}
          <div style={{ display: 'flex', gap: 8 }}>
            <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
              CEFR Level:
              <select value={fillInTheGapsLevel} onChange={e => setFillInTheGapsLevel(e.target.value)}
                style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer' }}>
                <option value="A1">A1 - Beginner</option>
                <option value="A2">A2 - Elementary</option>
                <option value="B1">B1 - Intermediate</option>
                <option value="B2">B2 - Upper Intermediate</option>
                <option value="C1">C1 - Advanced</option>
                <option value="C2">C2 - Mastery</option>
              </select>
            </label>
          </div>
          <button
            onClick={handleFillInTheGapsInsertCustom}
            disabled={!(fillInTheGapsCustomText.match(/\*\*(.+?)\*\*/g) || []).length}
            className="magic-btn"
            style={{ fontSize: 15, padding: '12px 16px', borderRadius: 8, border: 'none', fontWeight: 600, transition: 'all 0.2s',
              background: (fillInTheGapsCustomText.match(/\*\*(.+?)\*\*/g) || []).length ? '#8a2be2' : '#e0e0e0',
              color: (fillInTheGapsCustomText.match(/\*\*(.+?)\*\*/g) || []).length ? '#fff' : '#999',
              cursor: (fillInTheGapsCustomText.match(/\*\*(.+?)\*\*/g) || []).length ? 'pointer' : 'not-allowed' }}>
            Add exercise
          </button>
        </>
      )}
    </div>
  );
}
